/**
 * Loyalty Points Date Filter functionality.
 *
 * Handles the date filter dropdown interaction for the loyalty points history widget.
 */

(function () {
	'use strict';

	document.addEventListener('DOMContentLoaded', () => {
		const filterDropdown = document.getElementById('loyalty-points-date-filter');
		if (!filterDropdown) {
			return;
		}

		filterDropdown.addEventListener('change', function () {
			const selectedValue = this.value;
			const selectedText = this.options[this.selectedIndex].text;
			const displayElement = this.parentElement.querySelector('.agend-loyalty-points-filter-display');

			// Update display text immediately for better UX
			if (displayElement) {
				displayElement.textContent = selectedText;
			}

			const currentUrl = new URL(window.location.href);

			// Remove existing filter and page parameters.
			currentUrl.searchParams.delete('filter_month');
			currentUrl.searchParams.delete('pp');

			// Add new filter parameter if not 'all'.
			if (selectedValue !== 'all') {
				currentUrl.searchParams.set('filter_month', selectedValue);
			}

			// Redirect to the new URL
			window.location.href = currentUrl.toString();
		});
	});

})();
